export const Edit = 'edit';
export const Delete = 'delete';
export const Duplicate = 'duplicate';
export const DuplicateForDigital = 'duplicateForDigital';
export const GetTrackFromDigital = 'getTrackFromDigital';
export const GetTrackFromPhysical = 'getTrackFromPhysical';
